import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Terug',
  },
  metrics: {
    impressions: {
      label: 'Vertoningen',
      description: 'Het aantal keren dat uw advertentie is weergegeven in Google-zoekresultaten of op partnerwebsites.',
    },
    clicks: {
      label: 'Klikken',
      description: 'Het aantal keren dat mensen op uw advertentie hebben geklikt.',
    },
    budget_spent: {
      label: 'Besteed budget',
      description: 'Het totale bedrag dat aan deze campagne is uitgegeven.',
    },
    absolute_top_impression_percentage: {
      label: 'Absoluut top indruk %',
      description: 'Het percentage keren dat uw advertentie helemaal bovenaan de Google-zoekresultaten verscheen.',
    },
    phone_calls: {
      label: 'Oproepen',
      description: 'Het totale aantal telefonische oproepen via uw advertentie.',
    },
    phone_impressions: {
      label: 'Telefoonindrukken',
      description: 'Het aantal keren dat uw telefoonnummer in de advertentie werd weergegeven.',
    },
    phone_through_rate: {
      label: 'Telefoonklikratio',
      description: 'Het percentage telefoonindrukken dat resulteerde in een oproep (Oproepen ÷ Telefoonindrukken).',
    },
    directions: {
      label: 'Routebeschrijvingen',
      description: 'Het aantal keren dat gebruikers klikten voor een routebeschrijving naar uw locatie.',
    },
    daily_budget: {
      label: 'Dagelijks budget',
      description: 'Het maximale bedrag per dag voor deze campagne.',
    },
    status: {
      label: 'Status',
      description: 'De huidige uitvoerstatus van uw campagne.',
    },
    ctr: {
      label: 'Doorklikratio',
      description: 'Het percentage advertentieweergaven dat resulteerde in klikken (Klikken ÷ Indrukken).',
    },
    average_cpc: {
      label: 'Gemiddelde kosten per klik',
      description: 'Het gemiddelde bedrag dat u betaalt per klik op uw advertentie (Totale kosten ÷ Totale klikken).',
    },
    conversions_from_interactions_rate: {
      label: 'Conversieratio',
      description: 'Het percentage advertentie-interacties dat leidde tot een conversie.',
    },
    start_date: {
      label: 'Startdatum',
      description: 'De datum waarop de campagne is gestart.',
    },
    sales_from_google_ads: {
      label: 'Omzet via Google Ads',
      description: 'Het totale bedrag gegenereerd via Google Ads.',
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Niet opgegeven',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Ingeschakeld',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Gepauzeerd',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Onbekend',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Verwijderd',
  },
  error_messages: {
    loading_failed: 'Laden van campagnegegevens mislukt. Probeer het opnieuw.',
  },
};
